import { ExtendedRawUserProfile } from 'hooks/useIdentifyAnalytics/types';
import { getPianoCookieClient } from 'utils/getPianoCookieClient';
import { getSubscriptionName } from 'utils/getSubscriptionName';

import type { HeaderUserData, FooterUserData } from './types';
import {
  headerProfileMapFactory,
  footerProfileMapFactory
} from './profileMapFactory';

export const getHeaderUserData = (
  RIVTProfile: Nullable<ExtendedRawUserProfile>
): HeaderUserData => {
  const pianoUser = getPianoCookieClient();

  if (!pianoUser || !RIVTProfile) {
    return null;
  }

  const profileMap = headerProfileMapFactory(RIVTProfile);
  const emailStatus = pianoUser.email_verified ? 'verified' : 'unverified';
  const membership = getSubscriptionName(pianoUser.roles);

  return {
    actingProfileID: pianoUser.uuid,
    profileMap,
    membership,
    emailStatus
  };
};

export const getFooterUserData = (
  RIVTProfile: Nullable<ExtendedRawUserProfile>
): FooterUserData => {
  const pianoUser = getPianoCookieClient();

  if (!pianoUser || !RIVTProfile) {
    return null;
  }

  const profileMap = footerProfileMapFactory(RIVTProfile, pianoUser);

  return {
    actingProfileID: pianoUser.uuid,
    profileMap
  };
};
